import Route from '@ember/routing/route';

export default class CommunicationRoute extends Route {}
